import { render, staticRenderFns } from "./ProfileInterests.vue?vue&type=template&id=1b7517ca&"
import script from "./ProfileInterests.vue?vue&type=script&lang=js&"
export * from "./ProfileInterests.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInterests.vue?vue&type=style&index=0&id=1b7517ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports